import { ExtractErrorDetails } from "./Errorservice";
import {
  ExtractSortBy,
  ExtractFilterBy,
  requestOptionsForGET,
  requestOptionsForPATCH,
  requestOptionsForDELETE,
  requestOptionsForPOST,
} from "./CommonServices";

const baseUrl = process.env.REACT_APP_APPHUB_API_ENDPOINT;
//const baseUrl = process.env.APPHUB_API_ENDPOINT;

export const deleteMaintenance = async (id) => {
  var options = requestOptionsForPATCH();
  const response = fetch(baseUrl + "maintenance/delete/" + id, options).then(async (res) => {
    const data = await res.json();
    if (!res.ok) {
      const error = ExtractErrorDetails(res, data);
      return Promise.reject(error);
    }
    return data;
  });
  return response;
};

export const postMaintenance = async (data) => {
  var options = requestOptionsForPOST(data);
  const response = fetch(baseUrl + "maintenance", options)
    .then(async (res) => {
      const data = await res.json();
      // check for error response
      if (!res.ok) {
        // get error message from body or default to response statusText
        //const error = (data && data.message) || res.statusText;
        const error = ExtractErrorDetails(res, data);
        return Promise.reject(error);
      }
      return data;
    })
   
    .catch((error) => {
      return Promise.reject(error);
    });
  return response;
};

export const fetchMaintenance = async (id) => {
  var options = requestOptionsForGET();
  const response = fetch(baseUrl + "maintenance/" + id, options).then((data) => {
    return data.json();
  });
  return response;
};

export const patchMaintenance = async (data) => {
  var options = requestOptionsForPATCH(data);
  const response = fetch(baseUrl + "maintenance/" + data.maintenanceId, options).then(
    async (res) => {
      const data = await res.json();
      // check for error response
      if (!res.ok) {
        // get error message from body or default to response statusText
        const error = ExtractErrorDetails(res, data);
        return Promise.reject(error);
      }
      return data;
    }
  );
 
  return response;
};

export const fetchMaintenanceList = async (
  pageIndex = 1,
  pageSize = 5,
  sorting = [],
  filtering = []
) => {
  const sortstr =
    sorting === undefined || sorting.length === 0 ? "" : ExtractSortBy(sorting);
  const filterstr =
    filtering === undefined || filtering.length === 0
      ? ""
      : ExtractFilterBy(filtering);

  var options = requestOptionsForGET();
  //const response = CustomAnswers
  let querystr = "";
  querystr =
    "?PageNumber=" + pageIndex + "&Limit=" + pageSize + sortstr + filterstr;
  const response = fetch(baseUrl + "Maintenance/GetMaintenanceData/" + querystr, options)
    .then(async (res) => {
      const data = await res.json();
      // check for error response
      if (!res.ok) {
        // get error message from body or default to response statusText
        const error = (data && data.message) || res.statusText;
        return Promise.reject(error);
      }
      return data;
    })
    .catch((error) => {
      console.error("There was an error!", error.toString());
    });
  return response;
};
